import {Component, inject, Input} from '@angular/core';
import {map} from 'rxjs';
import {
    AppointmentAgingScoreQuery,
    AppointmentsClient,
    GetAppointmentComplianceScoreQuery,
    IMyScoreShiftQuery,
    InboundProductivityScoreQuery,
    InventoryClient,
    PermissionType,
    ScoreDto,
    SLAScoreQuery,
    TagsRequiredScoreQuery,
} from '@services';
import {DoughnutChartComponent} from '../../../components/library/doughnut-chart/doughnut-chart.component';
import {appointmentAgingPalette} from '../../inbound/appointment-score/appointment-aging-score/appointment-aging-score.component';
import {tagsRequiredPalette} from '../../inbound/appointment-score/tags-required-score/tags-required-score.component';
import {complianceRing, complianceRingPalette} from '../../inbound/appointment-score/appointment-compliance-score/appointment-compliance-score.component';
import {inboundProductivityPalette} from '../../inbound/appointment-score/inbound-productivity-score/inbound-productivity-score.component';
import {DashboardAccess} from '../dashboard-access';
import {DashboardCardComponent} from '../dashboard-card/dashboard-card.component';

@Component({
    selector: 'app-dashboard-inbound',
    imports: [DoughnutChartComponent, DashboardCardComponent],
    templateUrl: './dashboard-inbound.component.html',
})
export class DashboardInboundComponent {
    @Input() from: Date;
    @Input() to: Date;

    protected access = inject(DashboardAccess);
    private appointmentsClient = inject(AppointmentsClient);
    private inventoryClient = inject(InventoryClient);

    protected readonly palettes = {
        appointmentAging: appointmentAgingPalette(),
        tagsRequired: tagsRequiredPalette(),
        appointmentCompliance: complianceRingPalette(),
        inboundProductivity: inboundProductivityPalette(),
    };

    private readonly inboundProductivityUserId = this.access.ownUnlessManage(PermissionType.InboundProductivityScore);

    protected loadAppointmentAging = (query: IMyScoreShiftQuery) =>
        this.appointmentsClient.getAppointmentAgingScore(new AppointmentAgingScoreQuery(query));

    protected loadTagsRequired = (query: IMyScoreShiftQuery) =>
        this.appointmentsClient.getTagsRequiredScore(new TagsRequiredScoreQuery(query));

    protected loadAppointmentCompliance = (query: IMyScoreShiftQuery) =>
        this.appointmentsClient
            .getAppointmentComplianceScore(new GetAppointmentComplianceScoreQuery({from: query.from, to: query.to}))
            .pipe(map(dto => {
                const totals = Object.fromEntries(complianceRing(dto).map(slice => [slice.argument, slice.value]));
                return new ScoreDto({avgScorePercent: dto.avgScorePercent, totals});
            }));

    protected loadInboundProductivity = (query: IMyScoreShiftQuery) =>
        this.appointmentsClient.getInboundProductivityScore(new InboundProductivityScoreQuery({
            from: query.from!,
            to: query.to,
            employeeIds: this.inboundProductivityUserId ? [this.inboundProductivityUserId] : undefined,
        }));

    protected loadDamaged210 = (query: IMyScoreShiftQuery) =>
        this.inventoryClient.getSLAScore(new SLAScoreQuery({...query, storageTypeCode: '210'}));
}
